import router from './router';
import socket from './socket';
import login from './login';
import modal from './modal';
import user from './user';
import project from './project';
import projectMembership from './project-membership';
import board from './board';
import label from './label';
import list from './list';
import card from './card';
import task from './task';
import attachment from './attachment';
import actions from './actions';
import commentAction from './comment-action';
import notification from './notification';

export default [
  router,
  socket,
  login,
  modal,
  user,
  project,
  projectMembership,
  board,
  label,
  list,
  card,
  task,
  attachment,
  actions,
  commentAction,
  notification,
];
